module.exports = __webpack_public_path__ + "img/152-Balmoral.jpg";